import React from "react";
import arrowLeft from "../assets/images/navbar/arrow-left.png";
import cancel from "../assets/images/navbar/cancel.png";
import { ABOUT_US } from "../data/staticContent";

type AboutUsProps = {
  onClose: () => void;
};

const AboutUs = ({ onClose }: AboutUsProps) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 z-[70]" onClick={onClose}>
    <div
      className="fixed right-0 top-0 h-full w-full max-w-[450px] bg-white dark:bg-gray-900 rounded-l-[20px] overflow-y-auto"
      style={{ animation: "slideInRight 0.3s ease-out" }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="sticky top-0 bg-white dark:bg-gray-900 z-10 px-6 py-4 border-b dark:border-gray-700">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={arrowLeft} alt="back" className="w-[36px] h-[36px] rounded-full border cursor-pointer p-2" onClick={onClose} />
            <h2 className="text-[#040404] dark:text-gray-200 font-Urbanist text-[20px] font-semibold">About Us</h2>
          </div>
          <img src={cancel} alt="close" className="w-[36px] h-[36px] p-2 rounded-full border cursor-pointer" onClick={onClose} />
        </div>
      </div>
      <div className="px-6 py-4 space-y-6">
        {ABOUT_US.map((section, index) => (
          <div key={index}>
            {section.title && (
              <h3 className="text-[#050505] dark:text-gray-200 font-Urbanist text-[18px] font-semibold mb-2">
                {section.title}
              </h3>
            )}
            {section.paragraphs.map((paragraph) => (
              <p key={paragraph} className="text-[#6A6A6A] dark:text-gray-400 font-Urbanist text-[15px] leading-6 mb-2">
                {paragraph}
              </p>
            ))}
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default AboutUs;
